import { Logger } from "./log.js";
const { warn } = Logger("zeed:promise");
/** Sleep for `milliSeconds`. Example 1s: `await sleep(1000)` */
export async function sleep(milliSeconds) {
    return new Promise((resolve) => setTimeout(resolve, milliSeconds));
}
export async function immediate() {
    return new Promise((resolve) => setTimeout(resolve, 0));
}
export const timeoutReached = Symbol("timeout");
export async function timeout(promise, milliSeconds, timeoutValue = timeoutReached) {
    return new Promise(async (resolve, reject) => {
        let done = false;
        const timeout = setTimeout(() => {
            done = true;
            resolve(timeoutValue);
        }, milliSeconds);
        try {
            let result = await promise;
            clearTimeout(timeout);
            if (!done)
                resolve(result);
        }
        catch (err) {
            clearTimeout(timeout);
            if (!done)
                reject(err);
        }
    });
}
export const timoutError = new Error("Timeout reached");
export function isTimeout(value) {
    return value === timeoutReached || value === timoutError;
}
export async function tryTimeout(promise, milliSeconds) {
    return new Promise(async (resolve, reject) => {
        let done = false;
        const timeout = setTimeout(() => {
            done = true;
            reject(timoutError);
        }, milliSeconds);
        try {
            let result = await promise;
            clearTimeout(timeout);
            if (!done)
                resolve(result);
        }
        catch (err) {
            clearTimeout(timeout);
            if (!done)
                reject(err);
        }
    });
}
/** Wait for `event` on `obj` to emit. Resolve with result or reject on `timeout` */
export function waitOn(obj, event, timeoutMS = 1000) {
    return new Promise((resolve, reject) => {
        let fn = (value) => {
            if (timer) {
                clearTimeout(timer);
                done();
                resolve(value);
            }
        };
        let done = () => {
            timer = null;
            if (obj.off) {
                obj.off(event, fn);
            }
            else if (obj.removeEventListener) {
                obj.removeEventListener(event, fn);
            }
            else {
                warn("No remove listener method found for", obj, event);
            }
        };
        let timer = setTimeout(() => {
            done();
            reject(new Error(`Did not response in time`));
        }, timeoutMS);
        if (obj.on) {
            obj.on(event, fn);
        }
        else if (obj.addEventListener) {
            obj.addEventListener(event, fn);
        }
        else {
            warn("No listener method found for", obj);
        }
    });
}
/** @deprecated */
export function isPromise(value) {
    return Boolean(value &&
        (value instanceof Promise ||
            // @ts-ignore
            typeof value.then === "function"));
}
/** This is exactly what Prose.resolve(x) is supposed to be: return a Promise no matter what type x is */
export function promisify(value) {
    // return isPromise(value) ? value : Promise.resolve(value)
    return Promise.resolve(value);
}
//# sourceMappingURL=promise.js.map